import { Component, inject } from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { BottomMenuInternalViewMoreItemsComponent } from "../bottom-menu-internal-view-more-items/bottom-menu-internal-view-more-items.component";
import { BottomMenuItemComponent } from "../bottom-menu-item/bottom-menu-item.component";
import { RouterLink, RouterLinkActive } from "@angular/router";

@Component({
	selector: "app-bottom-menu-internal-view",
	imports: [BottomMenuItemComponent, RouterLink, RouterLinkActive],
	templateUrl: "./bottom-menu-internal-view.component.html",
})
export class BottomMenuInternalViewComponent {
	private bottomSheet = inject(MatBottomSheet);

	showMore(): void {
		this.bottomSheet.open(BottomMenuInternalViewMoreItemsComponent);
	}
}
